export enum StickyLocation {
  Top = 'Top',
  Bottom = 'Bottom',
  BelowHeader = 'BelowHeader',
}
